function adjustHeaderHeight() {
  if (!document.querySelector('.flexible-top')) {
    return;
  }

  const articleHeader = document.querySelector('article.media-library > header.article-header .flexible-top');
  const videoContainer = document.querySelector('article.media-library > section.entry-content .video-fake');
  if (!articleHeader || !videoContainer) return;
  const videoContainerHeight = videoContainer.scrollHeight || 0;

  articleHeader.style.height = videoContainerHeight + 'px';
}
